<app-loading-indicator [loading]="loading"></app-loading-indicator>

<p-card *ngIf="!loading" id="pdf-content">

  <div class="p-grid" style="margin: -1.5rem 0;">
    <div class="p-col-6 p-md-6 p-sm-6" *ngIf="!breakEven"><h3 [style]="{ fontWeight: '600' }">{{'INCOME_EXPENSE_ANALYSIS' | translate}}</h3></div>
    <div class="p-col-6 p-md-6 p-sm-6" *ngIf="breakEven"><h3 [style]="{ fontWeight: '600' }">{{'BREAK_EVEN_COST_ANALYSIS' | translate}}</h3></div>
    <div class="p-col-6 p-md-6 p-sm-6">
      <app-page-info [pageName]="'daily-income'"></app-page-info>
      <p-button icon="pi pi-file-excel" [style]="{marginLeft: '5px', float:'right'}"></p-button>
      <p-button icon="pi pi-file-pdf" (click)="generatePDF()" [style]="{marginLeft: '5px', float:'right'}"></p-button>
    </div>
  </div>
  <div class="p-grid" id="button">
    <div class="p-col-12 p-md-6 p-lg-3">
      <p-dropdown
        [style]="{width: '100% !important',border:'none',borderBottom: '2px solid #47bfd4'}"
        [options]="locations" appendTo="body" (onChange)="onSelectLocation($event)"
        [ngModel]="parameters.location"
        optionLabel="name" optionValue="id" placeholder="{{ 'SELECT_LOCATION'| translate}}"
        [filter]="true" filterBy="name">
      </p-dropdown>
    </div>
    <div class="p-col-12 p-md-6 p-lg-3">
      <p-calendar id="start" name="start"  selectionMode="range" dateFormat="yy-mm-dd" date [showTime]="false"
                  [style]="{width: '100%',border:'none', borderBottom: '2px solid #47bfd4'}" appendTo="body"
                  [(ngModel)]="dateRange" (ngModelChange)="onSelectDate($event)"
                  placeholder="{{'SELECT_DATE'| translate}}">
      </p-calendar>
    </div>
    <div class="p-col-12 p-md-6 p-lg-2">
      <p-button [style]="{height: '100%'}" type="submit" (click)="load()" label="{{'SEARCH' | translate}}"></p-button>
    </div>
  </div>
  <div id="pdfContent">
    <div class="p-grid" >
      <div class="p-col-12">
        <div class="p-col div-sums" style="padding: 0px !important">
          <div>
            <div class="inside-div-no-background" style="padding: 3px !important" >
              <p-table [value]="saleDates" styleClass="p-datatable-sm" [scrollable]="isScrollable" scrollHeight="600px">
                <ng-template pTemplate="header">
                  <tr>
                    <th [style]="{width: '10%'}" pSortableColumn="saleDate">
                      <p-sortIcon field="saleDate"></p-sortIcon>{{'DATE' | translate}}</th>
                    <th [style]="{width: '12%'}" pSortableColumn="netTotal">
                      <p-sortIcon field="netTotal"></p-sortIcon>{{'NET_INCOME' | translate}}</th>
                    <th [style]="{width: '12%'}" pSortableColumn="totalCost">
                      <p-sortIcon field="totalCost"></p-sortIcon>{{'EXPENSE' | translate}}</th>
                    <th [style]="{width: '8%'}" pSortableColumn="costRate">
                      <p-sortIcon field="costRate"></p-sortIcon>{{'COST' | translate}} %</th>
                    <th [style]="{width: '12%'}" pSortableColumn="profit">
                      <p-sortIcon field="profit"></p-sortIcon>{{'PROFIT' | translate}}/{{'LOSS' | translate}}</th>
                    <th [style]="{width: '8%'}" pSortableColumn="profitRate">
                      <p-sortIcon field="profitRate"></p-sortIcon>{{'PROFIT' | translate}}/{{'LOSS' | translate}} %</th>
                    <th [style]="{width: '7%'}" pSortableColumn="cuver">
                      <p-sortIcon field="cuver"></p-sortIcon>{{'TOTAL_NUMBER_OF_CUSTOMER' | translate}}</th>
                    <th [style]="{width: '9%'}" pSortableColumn="cuverNet">
                      <p-sortIcon field="cuverNet"></p-sortIcon>{{'AVERAGE_INCOME_PER_CUSTOMER' | translate}}</th>
                    <th [style]="{width: '8%'}" pSortableColumn="cuverCost">
                      <p-sortIcon field="cuverCost"></p-sortIcon>{{'AVERAGE_EXPENSE_PER_CUSTOMER' | translate}}</th>
                    <th *ngIf="breakEven" [style]="{width: '12%'}"> {{'OPERATING_COST' | translate}} </th>
                    <th *ngIf="breakEven" [style]="{width: '12%'}"> {{'DRESSED_COST' | translate}}</th>
                    <th *ngIf="breakEven" [style]="{width: '8%'}"> {{'COST' | translate}} %</th>
                    <th *ngIf="breakEven" [style]="{width: '12%'}">{{'PROFIT' | translate}}/{{'LOSS' | translate}}</th>
                    <th *ngIf="breakEven" [style]="{width: '8%'}">{{'PROFIT' | translate}}/{{'LOSS' | translate}} %</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dates>
                  <tr >
                    <td [style]="{width: '10%'}">{{dates.saleDate}}</td>
                    <td [style]="{textAlign:'right', width: '12%'}">{{(dates.netTotal) | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '12%'}" >{{(dates.totalCost) | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '8%'}" >{{(dates.costRate) | number :'1.2-2'}}%</td>
                    <td [style]="{textAlign:'right', width: '12%'}" >{{(dates.profit) | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '8%'}" >{{(dates.profitRate)  | number :'1.2-2'}}%</td>
                    <td [style]="{textAlign:'right', width: '7%'}">{{(dates.cuver)}}</td>
                    <td [style]="{textAlign:'right', width: '9%'}" >{{(dates.cuverNet)  | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '8%'}" >{{(dates.cuverCost) | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '12%'}" *ngIf="breakEven">{{(dates.expense ) | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '12%'}" *ngIf="breakEven">{{((dates.totalCost + (dates.expense))) | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '8%'}" *ngIf="breakEven">{{((dates.totalCost + (dates.expense)) / dates.netTotal) * 100 | number :'1.2-2'}}%</td>
                    <td [style]="{textAlign:'right', width: '12%'}" *ngIf="breakEven" [ngStyle]="{'color': (dates.netTotal - (dates.totalCost + dates.expense)) > 0 ? '#495057' : 'red'}">{{(dates.netTotal - (dates.totalCost + dates.expense)) | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '8%'}" *ngIf="breakEven" [ngStyle]="{'color': (dates.netTotal - (dates.totalCost + dates.expense)) > 0 ? '#495057' : 'red'}">{{ 100 - (((dates.totalCost + dates.expense) / dates.netTotal) * 100) | number :'1.2-2'}}%</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="footer">
                  <tr >
                    <td [style]="{width: '10%'}">{{'TOTAL' | translate}}</td>
                    <td [style]="{textAlign:'right', width: '12%'}">{{(sale?.netTotal) | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '12%'}" >{{sale?.totalCost | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '8%'}" >{{(sale?.totalCost / sale?.netTotal)*100 | number :'1.2-2'}}%</td>
                    <td [style]="{textAlign:'right', width: '12%'}" >{{sale?.netTotal - sale?.totalCost | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '8%'}" >{{((sale?.netTotal - sale?.totalCost) / sale?.netTotal) * 100 | number :'1.2-2'}}%</td>
                    <td [style]="{textAlign:'right', width: '7%'}">{{(sale?.totalCuver)}}</td>
                    <td [style]="{textAlign:'right', width: '9%'}" >{{(sale?.netTotal / sale?.totalCuver) | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '8%'}" >{{(sale?.totalCost / sale?.totalCuver)| countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '12%'}" *ngIf="breakEven">{{sale?.breakEvenCost | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '12%'}" *ngIf="breakEven">{{sale?.breakEvenCost + sale?.totalCost | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '8%'}" *ngIf="breakEven">{{((sale?.breakEvenCost + sale?.totalCost) / sale?.netTotal)*100 | number :'1.2-2'}}%</td>
                    <td [style]="{textAlign:'right', width: '12%'}" *ngIf="breakEven" [ngStyle]="{'color': (sale.netTotal - sale?.breakEvenCost) > 0 ? '#495057' : 'red'}">{{sale?.netTotal - (sale?.breakEvenCost + sale?.totalCost) | countryCurrency}}</td>
                    <td [style]="{textAlign:'right', width: '8%'}" *ngIf="breakEven" [ngStyle]="{'color': (sale.netTotal - sale?.breakEvenCost) > 0 ? '#495057' : 'red'}">{{((sale?.netTotal - (sale?.breakEvenCost + sale?.totalCost)) / sale?.netTotal) * 100 | number :'1.2-2'}}%</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
      <div class="p-col-12" *ngIf="!breakEven">
        <p-chart type="bar" [data]="data" [options]="chartOptions" height="400px"></p-chart>
      </div>
      <div class="p-col-12" *ngIf="breakEven">
        <p-chart type="bar" [data]="dataBreakEven" [options]="chartOptions" height="400px"></p-chart>
      </div>
    </div>
    <div class="p-grid" *ngIf="breakEven">
      <div class="p-col-4" [style]="{marginTop: '20px'}">
        <p-table [value]="groupedExpenses" dataKey="id" styleClass="p-datatable-sm" [loading]="loading">
          <ng-template pTemplate="header">
            <tr>
              <th [style]="{width:'8%'}"></th>
              <th [style]="{width:'62%'}" scope="col">{{ 'EXPENSE_TYPE' | translate}}</th>
              <th [style]="{width:'30%'}" scope="col">{{ 'MONTHLY_EXPENSE' | translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr>
              <td>{{i+1}}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.amount | number: '1.2-2' }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer">
            <tr>
              <td colspan="2" style="text-align: right;">{{'DAILY_EXPENSES'| translate}}</td>
              <td >{{ totalExpense / 30 | countryCurrency }}</td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: right;">{{'MONTHLY_EXPENSES'| translate}}</td>
              <td >{{ totalExpense | countryCurrency }}</td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: right;">{{'YEARLY_EXPENSES'| translate}}</td>
              <td >{{ totalExpense * 12 | countryCurrency }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="p-col-7" >
        <p-chart type="doughnut" [data]="dataExpense" [options]="chartOptionsExpense" [style]="{'width': '40%'}"></p-chart>
      </div>

    </div>
  </div>

</p-card>
